import React, {useState, useEffect} from 'react';
import {useNavigate, useParams} from "react-router-dom";
import {withTranslation} from 'react-i18next';
import {Panel} from "primereact/panel";
import {FileUpload} from "primereact/fileupload";
import axios from "axios";
import Cookies from "js-cookie";

import HelpComponent from "../HelpComponent";
import {Button} from "primereact/button";

const _FM_AccommodationImportFormComponent = (props) => {

  const {t} = props;
  const navigate = useNavigate();
  const {id, action} = useParams();

  return (
    <>
      <Panel className={"p-mt-3"}>
        <div className={"p-grid"}>
          <div className={"p-col p-col-align-center"}>
            <h2 className={"p-m-0"}>{t('accommodation_import')}</h2>
          </div>
          <div className={"p-col p-text-right p-col-align-center"}>
            <HelpComponent type={"site"} position={"UNDER_HELP_BUTTON"}/>
            <Button type="button"
                    icon={"pi pi-times"}
                    onClick={() => {
                      navigate(-1)
                    }}
                    className="p-button-secondary close p-ml-2">
            </Button>
          </div>
        </div>
        <div className={"p-grid"}>
          <div className={"p-col-12 p-lg-6 p-xl-6"}>
            <div className="p-field p-fluid">
              <HelpComponent type={"field"} field={"file"}/>
              <label htmlFor="file">{t('file')}</label>
              <span className="p-d-block">
                  <FileUpload mode="basic"
                              auto
                              chooseLabel={t('file_choose')}
                              name="file"
                              onSelect={(e) => {
                                axios.post(process.env.REACT_APP_API_PROTOCOL + process.env.REACT_APP_API_HOST + "accommodation/import/upload",
                                  {
                                    file: e.files[0]
                                  },
                                  {
                                    params: {},
                                    headers: {
                                      'Authorization': 'Bearer ' + Cookies.get("userToken"),
                                      "Sys-name": Cookies.get("instanceId"),
                                      "Preferred-locale": Cookies.get("language"),
                                      'Content-Type': 'multipart/form-data'
                                    }
                                  })
                                  .then(response => {
                                    navigate(-1);
                                    window.App.toastShow('success', t('success'), response.data.message)
                                  })
                                  .catch(error => {
                                    window.App.toastShow('error', t('error'), error.toString(), '', error.response);
                                  })
                              }}
                  />
              </span>
            </div>
          </div>
          <div className={"p-col-12 p-lg-6 p-xl-6"}>
            <div className="p-field p-fluid">
              <HelpComponent type={"field"} field={"template_download"}/>
              <label htmlFor="template_download">{t('template_download')}</label>
              <span className="p-d-block p-mt-2">
                  <a
                    href={'/download/accommodation_import_template.xlsx'}
                    download="accommodation_import_template.xlsx"
                    className="p-button p-component p-button-info"
                    style={{ textDecoration: 'none', display: 'inline', alignItems: 'center', justifyContent: 'center' }}
                  >
                      <span className="p-button-icon p-c p-button-icon-left pi pi-download"></span>
                      <span className="p-button-label p-c">{t('download')}</span>
                    </a>
              </span>
            </div>
          </div>
        </div>
      </Panel>
    </>
  )
}
export default withTranslation('common')(_FM_AccommodationImportFormComponent);
